import {
  FilterType,
  SelectFilter,
  SelectOption,
  StringFilterValue,
} from "../../types/filter";
import { SelectListView } from "../SelectListView/SelectListView";
import { useTranslation } from "@coworker/locales";
import { FilterAccordionItem } from "./FilterAccordionItem";
import { getFilterValueCount } from "../../utils/filter/filtervalue";

interface AccordionSelectProps {
  filter: SelectFilter;
  selected: StringFilterValue;
  onChange: (option: SelectOption) => void;
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export const AccordionSelect = ({
  filter,
  selected,
  onChange,
  open,
  onOpenChange,
}: AccordionSelectProps) => {
  const { title } = filter;
  const { t } = useTranslation();
  const filterValueCount = getFilterValueCount(filter, [selected]);

  return (
    <FilterAccordionItem
      filter={filter}
      open={!!open}
      onOpenChange={onOpenChange}
      title={
        filter.filterType === FilterType.Sort
          ? filterValueCount
            ? `${t("sortByTitleString")} (${filterValueCount})`
            : t("sortByTitleString")
          : filterValueCount
            ? `${title} (${filterValueCount})`
            : title
      }
    >
      <SelectListView
        prefix="accordion"
        filter={filter}
        selected={selected}
        onChange={onChange}
      />
    </FilterAccordionItem>
  );
};
